export default "__VITE_ASSET__a8ece4d3__"